import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M14.75 11.021a2.75 2.75 0 1 0-5.499 0 2.75 2.75 0 0 0 5.499.003v-.003ZM12 9.774a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M15.374 2.777H18.3c.863 0 1.574.711 1.574 1.575v16.646c0 .864-.71 1.574-1.575 1.574H5.703c-.864 0-1.575-.71-1.575-1.574V4.352c0-.864.71-1.575 1.575-1.575h2.924v-.675a.68.68 0 0 1 .675-.675H14.7a.68.68 0 0 1 .675.675v.675Zm-1.35 0H9.977v1.35h4.049v-1.35ZM18.3 21.223a.223.223 0 0 0 .224-.225V4.352a.223.223 0 0 0-.224-.225h-2.925v.675a.68.68 0 0 1-.675.675H9.301a.68.68 0 0 1-.675-.675v-.675H5.702a.223.223 0 0 0-.225.225v16.646c0 .126.099.225.225.225h.575a.75.75 0 0 1-.027-.2 5.75 5.75 0 0 1 11.5 0 .75.75 0 0 1-.027.2h.576Zm-2.022 0a.75.75 0 0 1-.027-.2 4.25 4.25 0 0 0-8.5 0 .75.75 0 0 1-.027.2h8.554Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  l,
  n
];
function d(r, s) {
  return t(), o("svg", c, [...a]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
